import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import LanguageDropdown from "components/CommonForBoth/TopbarDropdown/LanguageDropdown"
import {
  Row,
  Col,
  CardBody,
  Card,
  Container,
  Label,
  Form,
  FormFeedback,
  Input,
  InputGroupText,
  InputGroup,
  Button,
} from "reactstrap"
import { Alert, message as AntMessage, Typography } from "antd"

import { useTranslation } from "react-i18next"
// import { login } from "helpers/api_helper"
import { useLocation, useNavigate } from "react-router-dom"
import { login } from "services/authservice"

// Redux

import { connect, useSelector, useDispatch } from "react-redux"
import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"
const { Paragraph, Text } = Typography;
// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"

// actions
// import { loginUser, apiError } from "../../store/actions"
import { loginUser } from "store/auth/login/loginSlice"

// import images
import logoSm from "../../assets/images/logo-sm.png"
import logo from "../../assets/images/logo.png"
import PaymentInfoPopup from "./PaymentInfoPopup"
import PaypalCheckout from "./PaypalCheckout"

const Login = (props) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [userLogin, setUserLogin] = useState([])
  const [showPassword, setShowPassword] = useState(false)
  const { user, error, loading } = useSelector((state) => state.Login)
  const navigate = useNavigate()
  const location = useLocation();
  const [flashMessage, setFlashMessage] = useState(null);
  const [flashType, setFlashType] = useState("success");
  const [responseData, setResponseData] = useState(null);
  const [emailData, setEmailData] = useState(null);
  const [showPaymentPopup, setShowPaymentPopup] = useState(null);
  const togglePaymentPopup = () => setShowPaymentPopup((v) => !v);
  useEffect(() => {
    // if (location.state?.message) {
    //   console.log(location.state?.message);

    //   // setFlashMessage(location.state.message);
    //   // setFlashType(location.state.type || "success");
    // }
    if (location.state?.email) {
      setTimeout(() => {
        setShowPaymentPopup(true);
        setEmailData(location.state?.email);
      }, 1500);
    }
  }, [location.state]);


  useEffect(() => {
    if (user && user) {
      setUserLogin({
        email: user.email,
        password: user.password,
      })
    }
  }, [user])

  useEffect(() => {
    if (responseData?.status === "Blocked") {
      AntMessage.info("Votre paiement a été refusé pour la raison suivante : " + responseData?.paymentRejectionReason)
    } else {
      if (responseData) {
        // if (responseData && responseData.imageChecked != null) {
        //   if (!responseData?.imageChecked) {
        //     setShowPaymentPopup(true)
        //   } else {
        //     AntMessage.info(responseData.message)
        //   }

        // } else {
        //   setShowPaymentPopup(false)
        //   AntMessage.info(responseData?.message)
        // }
        if (responseData.hasPaidWithPaypal || responseData.imageChecked != null) {
          if (responseData.hasPaidWithPaypal) {
            setShowPaymentPopup(false);
            AntMessage.success(responseData.message);
          } else if (responseData.imageChecked != null) {
            if (!responseData.imageChecked) {
              setShowPaymentPopup(true);
            } else {
              AntMessage.info(responseData.message);
            }
          } else {
            setShowPaymentPopup(false);
            AntMessage.info(responseData?.message);
          }
        } else {
          setShowPaymentPopup(false);
          AntMessage.info(responseData?.message);
        }

      }
    }

  }, [responseData])

  const handleLogin = async (values) => {
    try {
      const response = await login({ values, navigate });
      setResponseData(response);
      console.log(response);
      setEmailData(response?.email);

      // Handle successful login here if needed
    } catch (error) {
      // Handle login error here
      console.error("Login failed:", error);
      console.error("Login failed:", error.response.data.message);
      AntMessage.error(error.response.data.message)
      // You might want to show an error message to the user
    }
  }
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values need to be changed
    enableReinitialize: true,
    //for the  dispatch(loginUser({ user: values, history: navigate }))

    // initialValues: {
    //   email:  "lacasa17lacasa@gmail.com" || userLogin.email ,
    //   password: "Password123!" || userLogin.password 
    // },
    //for the handleLogin
    // initialValues: {
    //   email: userLogin.email || "admin@themesbrand.com" || "",
    //   password: userLogin.password || "123456" || "",
    // },
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required(t("login.usernameRequired")),
      password: Yup.string().required(t("login.passwordRequired")),
    }),
    onSubmit: (values) => {
      console.log(values)
      // dispatch(loginUser({ user: values, history: navigate }))
      handleLogin(values)
    },
  })
  document.title = "Login | Playmaker Club"

  return (
    <React.Fragment>
      <div className="d-flex justify-content-end">
        <div style={{ marginRight: "4%" }}>
          <LanguageDropdown />
        </div>

        <div className="home-btn d-none d-sm-block">
          <Link to="/" className="text-dark">
            <i className="fas fa-home h2" />
          </Link>
        </div>
      </div>
      {/* <div className="mt-3 text-center">
        <Button color="info" onClick={togglePaymentPopup}>
          Détails Abonnement
        </Button>
      </div> */}
      <PaymentInfoPopup
        open={showPaymentPopup}
        onClose={togglePaymentPopup}
        phoneNumber="+213 554 17 05 32"
        emailContact="team.playmaker.club@gmail.com"
        email={emailData}
      />
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">

            {flashMessage && (
              <Alert
                banner
                type={flashType}
                showIcon
                style={{ marginBottom: 24, borderRadius: 8 }}
                message={(
                  <Text strong style={{ fontSize: 16 }}>
                    {flashType === "success"
                      ? "Inscription réussie !"
                      : "Attention"}
                  </Text>
                )}
                description={(
                  <Paragraph
                    style={{
                      margin: 0,
                      textAlign: "justify",
                      lineHeight: 1.6,
                      color: "#333",
                      fontSize: 14,
                    }}
                  >
                    {flashMessage}
                  </Paragraph>
                )}
              />
            )}
            <Col md={8} lg={6} xl={4}>
              <Card className="overflow-hidden">
                <div className="bg-primary">
                  <div className="text-primary text-center p-4">
                    <h5 className="text-white font-size-20">
                      {t("login.welcomeBack")}{" "}
                      {/* Traduction de "Welcome Back" */}
                    </h5>
                    <p className="text-white-50">
                      {t("login.signInMessage")} {/* Traduction du message */}
                    </p>
                    <Link to="/" className="logo logo-admin">
                      <img src={logo} height="55" alt="logo" />
                    </Link>
                  </div>
                </div>

                <CardBody className="p-4">
                  <div className="p-3">
                    <Form
                      className="mt-4"
                      onSubmit={(e) => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                      action="#"
                    >
                      <div className="mb-3">
                        <Label className="form-label" htmlFor="username">
                          {t("login.username")} {/* Traduction de "Username" */}
                        </Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder={t("login.enterUsername")}
                          type="email"
                          id="username"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          // value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email
                              ? true
                              : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">
                            {validation.errors.email}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label" htmlFor="userpassword">
                          {t("login.password")} {/* Traduction de "Password" */}
                        </Label>

                        <InputGroup>
                          <Input
                            name="password"
                            type={showPassword ? 'text' : 'password'}
                            placeholder={t("login.enterPassword")}
                            // value={validation.values.password || ""}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                              validation.touched.password &&
                                validation.errors.password
                                ? true
                                : false
                            }
                          />
                          <InputGroupText
                            onClick={() => setShowPassword(ps => !ps)}
                            style={{ cursor: 'pointer' }}
                          >
                            <i className={`fas fa-eye${showPassword ? '-slash' : ''}`}></i>
                          </InputGroupText>
                          {validation.touched.password &&
                            validation.errors.password ? (
                            <FormFeedback type="invalid">
                              {validation.errors.password}
                            </FormFeedback>
                          ) : null}
                        </InputGroup>
                      </div>
                      <div className="mb-3 row">
                        <div className="col-sm-6">
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="customControlInline"
                            />
                            <label
                              className="form-check-label"
                              htmlFor="customControlInline"
                            >
                              {t("login.rememberMe")}{" "}
                              {/* Traduction de "Remember me" */}
                            </label>
                          </div>
                        </div>
                        <div className="col-sm-6 text-end">
                          <button
                            className="btn btn-primary w-md waves-effect waves-light"
                            type="submit"
                          >
                            {t("login.logInButton")}{" "}
                            {/* Traduction de "Log In" */}
                          </button>
                        </div>
                      </div>

                      <div className="mt-2 mb-0 row">
                        <div className="col-12 mt-4">
                          <Link to="/forgot-password">
                            <i className="mdi mdi-lock"></i>{" "}
                            {t("login.forgotPassword")}{" "}
                            {/* Traduction de "Forgot your password?" */}
                          </Link>
                        </div>
                      </div>
                    </Form>

                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  {t("login.noAccount")}{" "}
                  {/* Traduction de "Don't have an account ?" */}
                  <Link to="/register" className="fw-medium text-primary">
                    {t("login.signupNow")} {/* Traduction de "Signup now" */}
                  </Link>{" "}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

// const mapStateToProps = (state) => {
//   const { error } = state.Login
//   return { error }
// }

export default Login

// Login.propTypes = {
//   error: PropTypes.any,
//   history: PropTypes.object,
//   loginUser: PropTypes.func,
// }
